import useBookmarks from 'assets/models/bookmarks'

import styles from './index.css'

const BookmarksIconStatus = () => {
  const { hasBookmarks } = useBookmarks()

  if (!hasBookmarks) return null

  return <span className={styles.active}></span>
}

export default BookmarksIconStatus
